/* Dizzplace - probka ogladanego panelu jednym kliknieciem (snippets/product-sample-quick.liquid).
   Probka trafia do koszyka ZAWSZE jako zestaw, tak jak z konfiguratora:
   nosnik (cena, ilosc = liczba wzorow, wariant = liczba wzorow) plus probka
   (1 szt., zerowana rabatem „Probka w zestawie gratis"). Gdy w koszyku stoi
   zestaw z wolnym miejscem, probka do niego dolacza: nosnik przechodzi na
   wariant o jeden wiekszy, wiec cena zestawu idzie wedlug cennika.
   Kolejnosc przy dolaczaniu: najpierw dokladamy nowy nosnik i probke, dopiero
   potem zdejmujemy stary nosnik - awaria w polowie zostawia dwa nosniki
   (nadmiarowy sprzata szuflada koszyka przy otwarciu), a nie darmowa probke. */
(() => {
  const json = async (url, opcje) => {
    const odpowiedz = await fetch(
      url,
      Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opcje || {})
    );
    if (!odpowiedz.ok) {
      let powod = '';
      try { powod = (await odpowiedz.json()).description || ''; } catch (e) { /* brak tresci */ }
      const blad = new Error(powod);
      blad.dlaKlienta = Boolean(powod);
      throw blad;
    }
    return odpowiedz.json();
  };
  const koszyk = () => json('/cart.js');
  const dodaj = (items) => json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });
  const ustawIlosci = (updates) => json('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });

  const nazwaZTytulu = (tytul) => String(tytul || '').split('—')[0].trim();

  const initProbka = (root) => {
    if (root.dataset.podlaczony === '1') return;
    const przycisk = root.querySelector('[data-quick-sample-add]');
    const zrodlo = root.querySelector('[data-quick-sample-data]');
    if (!przycisk || !zrodlo) return;
    let dane;
    try {
      dane = JSON.parse(zrodlo.textContent);
    } catch (e) {
      return;
    }
    root.dataset.podlaczony = '1';

    const probka = Number(dane.probka);
    const warianty = (dane.warianty || []).map(Number);
    const etykieta = (n) => String(dane.etykieta || '__N__').replace('__N__', String(n));
    let wKoszyku = false;

    /* „Porownaj wszystkie probki" wstawia ten wzor w pierwsze okienko -
       ale gdy probka juz jest w koszyku, konfigurator zlozylby ja drugi raz
       w nowym zestawie. Wtedy odnosnik prowadzi do pustego konfiguratora. */
    const odnosnik = root.querySelector('.product-sample__all');
    const adresZWzorem = odnosnik ? odnosnik.getAttribute('href') : '';
    const adresBezWzoru = adresZWzorem.replace(/[?&]wzory=[^&#]*/, '').replace(/^([^?]*)&/, '$1?');

    const ustaw = (stan) => {
      if (odnosnik) odnosnik.setAttribute('href', stan === 'wkoszyku' ? adresBezWzoru : adresZWzorem);
      przycisk.dataset.stan = stan;
      przycisk.disabled = stan === 'dodaje';
      przycisk.textContent = stan === 'dodaje' ? dane.napisy.adding : stan === 'wkoszyku' ? dane.napisy.in_cart : dane.napisy.add;
    };

    const jestWKoszyku = (items) =>
      items.some((p) => p.variant_id === probka && p.properties && p.properties._zestaw_rola === 'probka');

    const sprawdz = async () => {
      try {
        wKoszyku = jestWKoszyku((await koszyk()).items || []);
      } catch (e) {
        return;
      }
      if (przycisk.dataset.stan !== 'dodaje') ustaw(wKoszyku ? 'wkoszyku' : 'dodaj');
    };

    /* Po udanym dodaniu nowego nosnika, a przed zdjeciem starego, zestaw ma
       dwa nosniki. Gdy cos przerwie ten moment, szuflada koszyka sprzata
       nadmiarowy przy otwarciu (sections/cart-drawer.liquid) - dlatego po
       bledzie tez ja otwieramy. */
    let dodanoCzesc = false;

    const dodajProbke = async () => {
      const items = (await koszyk()).items || [];
      if (jestWKoszyku(items)) return;

      const pozycjaProbki = (numer) => ({
        id: probka,
        quantity: 1,
        properties: { _zestaw: numer, _zestaw_rola: 'probka' },
      });

      /* Zestaw z wolnym miejscem: ostatnio dodany, bo to ten, ktory klient
         wlasnie kompletuje. Shopify oddaje najnowsze pozycje koszyka NA
         POCZATKU listy, wiec pierwszy pasujacy nosnik jest najnowszy.
         Limit i warianty bierzemy z samego nosnika. */
      const nosniki = items.filter((p) => p.properties && p.properties._zestaw_rola === 'nosnik' && p.properties._zestaw);
      let cel = null;
      for (let i = 0; i < nosniki.length && !cel; i += 1) {
        const nosnik = nosniki[i];
        const numer = nosnik.properties._zestaw;
        const probki = items.filter((p) => p.properties && p.properties._zestaw === numer && p.properties._zestaw_rola === 'probka');
        const lista = String(nosnik.properties._zestaw_warianty || '').split(',').filter(Boolean).map(Number);
        if (probki.length > 0 && probki.length < lista.length && lista[probki.length]) {
          cel = { nosnik, numer, probki, lista };
        }
      }

      if (cel) {
        const { nosnik, numer, probki, lista } = cel;
        const liczba = probki.length + 1;
        const wlasciwosci = {};
        Object.keys(nosnik.properties).forEach((k) => {
          if (k.charAt(0) === '_') wlasciwosci[k] = nosnik.properties[k];
        });
        /* Czytelne wpisy „Probka nr N" dla obslugi: nazwy z dotychczasowych
           wpisow nosnika (tak je zapisal konfigurator), a gdy sie rozjechaly -
           z tytulow probek w koszyku. */
        let nazwy = Object.keys(nosnik.properties)
          .filter((k) => k.charAt(0) !== '_')
          .map((k) => nosnik.properties[k])
          .filter(Boolean);
        if (nazwy.length !== probki.length) nazwy = probki.map((p) => nazwaZTytulu(p.product_title));
        nazwy.push(dane.nazwa);
        nazwy.forEach((nazwa, i) => { wlasciwosci[etykieta(i + 1)] = nazwa; });

        await dodaj([
          { id: lista[liczba - 1], quantity: liczba, properties: wlasciwosci },
          pozycjaProbki(numer),
        ]);
        dodanoCzesc = true;

        /* Stary nosnik po swiezym kluczu - po dodaniu Shopify przelicza rabat
           i dawne klucze pozycji przestaja byc wazne. */
        const poDodaniu = (await koszyk()).items || [];
        /* Wszystkie linie starego nosnika - Shopify rozbija go na dwie, gdy
           rabat obejmuje tylko czesc sztuk, a zdjecie jednej zostawialo
           w koszyku sztuke za pelna cene. */
        const zmiany = {};
        poDodaniu.forEach((p) => {
          if (
            p.properties &&
            p.properties._zestaw === numer &&
            p.properties._zestaw_rola === 'nosnik' &&
            p.variant_id === nosnik.variant_id &&
            p.variant_id !== lista[liczba - 1]
          ) zmiany[p.key] = 0;
        });
        if (Object.keys(zmiany).length) await ustawIlosci(zmiany);
        return;
      }

      const numer = `zestaw-${Date.now().toString(36)}`;
      await dodaj([
        {
          id: warianty[0],
          quantity: 1,
          properties: {
            [etykieta(1)]: dane.nazwa,
            _zestaw: numer,
            _zestaw_rola: 'nosnik',
            _zestaw_warianty: warianty.join(','),
          },
        },
        pozycjaProbki(numer),
      ]);
    };

    const pokazBlad = (tekst) => {
      if (window.wishlistBar && typeof window.wishlistBar.show === 'function') {
        window.wishlistBar.show({ text: tekst, error: true });
      } else {
        window.alert(tekst);
      }
    };

    const otworzKoszyk = async () => {
      if (window.dizzKoszyk) {
        await window.dizzKoszyk.otworz({ odswiez: true });
      } else {
        window.location.assign('/cart');
      }
    };

    przycisk.addEventListener('click', async () => {
      if (przycisk.dataset.stan === 'dodaje') return;
      if (wKoszyku) {
        otworzKoszyk();
        return;
      }
      /* Tryb firmowy bez rabatu na koncie: brak ceny = brak zakupu. Przycisk
         i tak chowa arkusz stylow, to drugi bezpiecznik. */
      if (window.dizzB2B && window.dizzB2B.zablokowane()) return;
      if (!warianty.length) return;

      ustaw('dodaje');
      dodanoCzesc = false;
      try {
        await dodajProbke();
        wKoszyku = true;
        ustaw('wkoszyku');
        await otworzKoszyk();
      } catch (e) {
        if (dodanoCzesc) {
          wKoszyku = true;
          ustaw('wkoszyku');
          otworzKoszyk();
          return;
        }
        ustaw(wKoszyku ? 'wkoszyku' : 'dodaj');
        pokazBlad((e && e.dlaKlienta && e.message) || dane.napisy.error || '');
      }
    });

    /* Szuflada oglasza kazda zmiane koszyka - probka mogla z niego zniknac. */
    document.addEventListener('koszyk:zmiana', sprawdz);
    sprawdz();
  };

  const init = () => document.querySelectorAll('[data-quick-sample]').forEach(initProbka);

  /* Przyklejony pasek na stronie samej probki naciska glowny przycisk probki,
     zeby probka zawsze szla jako zestaw (AUD-40). Bez szybkiego przycisku
     (np. brak zestawu w ustawieniach) prowadzi tam, dokad prowadzi odnosnik. */
  document.addEventListener('click', (zdarzenie) => {
    const pasek = zdarzenie.target.closest('[data-quick-sample-proxy]');
    if (!pasek || pasek.disabled) return;
    zdarzenie.preventDefault();
    const glowny = document.querySelector('[data-quick-sample] [data-quick-sample-add]');
    if (glowny) {
      glowny.click();
      return;
    }
    const odnosnik = document.querySelector('.product-sample__all, .product-cta a.button-cta');
    if (odnosnik) window.location.assign(odnosnik.href);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
